"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StickyDrawer = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledStickyDrawer = _interopRequireDefault(require("./styled-sticky-drawer"));
var _excluded = ["children", "className", "dataTestId", "open", "transition", "zIndex"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef;
var propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  open: _propTypes["default"].bool,
  transition: _propTypes["default"].string,
  zIndex: _propTypes["default"].string
};
var defaultProps = {
  className: undefined,
  dataTestId: undefined,
  open: false,
  transition: '200ms',
  zIndex: '1'
};
var StickyDrawer = exports.StickyDrawer = forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    open = _ref.open,
    transition = _ref.transition,
    zIndex = _ref.zIndex,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledStickyDrawer["default"], _extends({
    "aria-hidden": open ? undefined : true,
    className: className,
    "data-testid": dataTestId || 'fuse-sticky-drawer-test-id',
    open: open,
    ref: ref,
    transition: transition,
    zIndex: zIndex
  }, rest), children);
});
StickyDrawer.propTypes = propTypes;
StickyDrawer.defaultProps = defaultProps;
var _default = exports["default"] = StickyDrawer;